import { COLLECTIONS } from "constants/firebase";
import { ICategoryTag, IPrivateTag } from "types";
import { list, createDoc, editDoc } from "utils/firestore";

export const tags = {
  private: {
    list: () => list<IPrivateTag>(COLLECTIONS.PRIVATE_TAGS),
    create: (data: any) => createDoc(COLLECTIONS.PRIVATE_TAGS, data),
    edit: (id: string, data: any) =>
      editDoc(COLLECTIONS.PRIVATE_TAGS, id, data),
  },
  public: {
    list: () => list<ICategoryTag>(COLLECTIONS.CATEGORY_TAGS),
  },
};
